import _ from "./lodashUtils"

export const createCombinedOrderPriceBreakdown = (userCart, partnerCart) => {
  if (!userCart || !partnerCart) {
    return
  }
  let combinedPriceBreakdown = {}
  combinedPriceBreakdown.discount =
    _.get(userCart, "discount", 0) + _.get(partnerCart, "discount", 0)
  combinedPriceBreakdown.tax =
    _.get(userCart, "tax", 0) + _.get(partnerCart, "tax", 0)

  combinedPriceBreakdown.delivery_fee = _.get(userCart, "fees.0.value", 0)
  combinedPriceBreakdown.service_fee =
    _.get(userCart, "fees.1.value", 0) + _.get(partnerCart, "fees.1.value", 0)
  combinedPriceBreakdown.required_tip =
    _.get(userCart, "fees.2.value", 0) + _.get(partnerCart, "fees.2.value", 0)
  combinedPriceBreakdown.fees = [
    { name: "Delivery fee", value: combinedPriceBreakdown.delivery_fee },
    { name: "Service fee", value: combinedPriceBreakdown.service_fee },
    { name: "Required Tip", value: combinedPriceBreakdown.required_tip },
  ]
  combinedPriceBreakdown.subtotal =
    _.get(userCart, "subtotal", 0) + _.get(partnerCart, "subtotal", 0)
  combinedPriceBreakdown.total =
    combinedPriceBreakdown.tax +
    combinedPriceBreakdown.delivery_fee +
    combinedPriceBreakdown.service_fee +
    combinedPriceBreakdown.required_tip +
    _.get(userCart, "subtotal", 0) +
    _.get(partnerCart, "subtotal", 0) -
    combinedPriceBreakdown.discount
  return combinedPriceBreakdown
}
